/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{flex:auto}[_nghost-%COMP%]   .grid[_ngcontent-%COMP%]{display:inline-block}[_nghost-%COMP%]   mat-card.toolbar[_ngcontent-%COMP%]{border-radius:0}[_nghost-%COMP%]   mat-card.toolbar[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin-left:25px;margin-right:25px}[_nghost-%COMP%]   .content[_ngcontent-%COMP%]   mat-card[_ngcontent-%COMP%]{margin-left:40px;margin-right:40px;margin-bottom:20px}[_nghost-%COMP%]   .itm-description[_ngcontent-%COMP%]{display:inline-block;margin-left:1em;font-style:italic}"];
export { styles as styles };
